import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../components/header'
import Footer from '../../components/footer'
import Head from '../../components/head';
import ConsultarSolic from '../../components/publico/consultar'

function ConsultarSolicScreen() {
        return (
            <Fragment>
                <Head titulo="Consulte sua solicitação | Departamento de TI" />
                <HeaderLogged />
                <Container>
                   <ConsultarSolic />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default ConsultarSolicScreen;